import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Gateway from "./Gateway";
import { staffIsAdmin } from "../../utils/staffIsAdmin";
import "./Sitesettings.css";

const IMPORT_WALLET_CONFIRM_PHRASE = "IMPORT WALLET BACKUP";

const SETTINGS_TABS = [
  { id: "general", label: "General" },
  { id: "money", label: "Money & Games" },
  { id: "kyc", label: "KYC & Ludo" },
  { id: "notices", label: "Notices" },
  { id: "access", label: "Access" },
];

function TabPanel({ id, activeTab, children }) {
  if (id !== activeTab) return null;
  return <div className="ss-tab-panel">{children}</div>;
}

function QuickToggleCard({ name, checked, onChange, label }) {
  return (
    <div className={`ss-quick-card ${checked ? "" : "ss-quick-card--off"}`}>
      <div className="ss-quick-card__text">
        <span className="ss-quick-card__label">{label}</span>
        <span className={`ss-quick-card__status ${checked ? "on" : "off"}`}>
          {checked ? "ON" : "OFF"}
        </span>
      </div>
      <label className="switch">
        <input type="checkbox" name={name} checked={checked} onChange={onChange} />
        <span className="slider" />
      </label>
    </div>
  );
}

export const Sitesettings = () => {
  const [settings, setSettings] = useState({
    WebTitle: "",
    WebsiteName: "",
    CompanyName: "",
    CompanyAddress: "",
    CompanyMobile: "",
    CompanyEmail: "",
    CompanyWebsite: "",
    telegramUsername: "",
    Logo: "",
    SmallLogo: "",
    LandingImage1: "",
    LandingImage2: "",
    LandingImage3: "",
    LandingImage4: "",
    isLandingImage1: true,
    isLandingImage2: true,
    isLandingImage3: true,
    isLandingImage4: true,
    version: "",
    settingId: "",
    DepositNotice: "",
    WithdrawNotice: "",
    HomepageNotice: "",
    MainpageNotice: "",
    isDepositNoticeActive: true,
    isWithdrawNoticeActive: true,
    isHomepageNoticeActive: true,
    isMainpageNoticeActive: true,
    isMaintenanceMode: false,
    MaintenanceMessage: "Website is under maintenance. Please try again later.",
    newRegistrationEnabled: true,
    newRegistrationClosedMessage: "",
    minDepositAmt: "",
    minFirstDepositForWithdraw: "300",
    minWithdrawAmtUPI: "",
    minWithdrawAmtBank: "",
    minBetAmt: "",
    maxBetAmt: "",
    adminCommissionPct: "",
    referralCommissionPct: "",
    withdrawCashbackEnabled: true,
    withdrawCashbackPercent: "2",
    withdrawCooldownHours: "3",
    userWithdrawCancelEnabled: true,
    signupBonusAmount: "10",
    aadhaarOtpKycEnabled: false,
    aadhaarManualKycEnabled: true,
    kycRequiredForPlay: false,
    ludoKingApiEnabled: false,
    ludoRichGameEnabled: false,
    ludoRichMinBetAmt: "",
    ludoRichMaxBetAmt: "",
  });

  const [fakeBattleEnabled, setFakeBattleEnabled] = useState(false);
  const [fakeBattleLoading, setFakeBattleLoading] = useState(false);
  const [fakeRunningBattleEnabled, setFakeRunningBattleEnabled] = useState(false);
  const [fakeRunningBattleLoading, setFakeRunningBattleLoading] = useState(false);
  const [backupPreview, setBackupPreview] = useState(null);
  const [backupPreviewLoading, setBackupPreviewLoading] = useState(false);
  const [backupDownloading, setBackupDownloading] = useState(false);
  const [importWalletFile, setImportWalletFile] = useState(null);
  const [importWalletPreview, setImportWalletPreview] = useState(null);
  const [importWalletPreviewLoading, setImportWalletPreviewLoading] = useState(false);
  const [importWalletApplying, setImportWalletApplying] = useState(false);
  const [ledgerSyncLoading, setLedgerSyncLoading] = useState(false);
  const [negativeLedgerRepairLoading, setNegativeLedgerRepairLoading] = useState(false);
  const [backupToolsOpen, setBackupToolsOpen] = useState(false);
  const importWalletFileRef = useRef(null);
  const isAdmin = staffIsAdmin();
  const [fakeBattleStatus, setFakeBattleStatus] = useState({
    activeCount: 0,
    maxAllowed: 10,
    currentLargeBattles: 0,
    maxLargeBattles: 2,
    burstMode: false,
    battleTypeBreakdown: {
      flash3s: 0,
      tenSeconds: 0,
      highValue: 0,
      regular: 0
    }
  });

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  const [logoLoading, setLogoLoading] = useState(false);
  const [landingImageLoading, setLandingImageLoading] = useState(false);
  const fileRefs = {
    Logo: useRef(null),
    SmallLogo: useRef(null),
    LandingImage1: useRef(null),
    LandingImage2: useRef(null),
  };

  const baseUrl = process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BACKEND_LOCAL_API
    : process.env.REACT_APP_BACKEND_LIVE_API;

  const fetchFakeBattleStatus = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(baseUrl + "challange/fake/status", {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFakeBattleEnabled(Boolean(response.data.enabled));
      setFakeRunningBattleEnabled(Boolean(response.data.runningEnabled));
      setFakeBattleStatus({
        activeCount: response.data.activeCount,
        maxAllowed: response.data.maxAllowed,
        currentLargeBattles: response.data.currentLargeBattles,
        maxLargeBattles: response.data.maxLargeBattles,
        burstMode: response.data.burstMode,
        battleTypeBreakdown: response.data.battleTypeBreakdown || {
          flash3s: 0,
          tenSeconds: 0,
          highValue: 0,
          regular: 0
        }
      });
    } catch (error) {
      console.error("Failed to fetch fake battle status:", error);
    }
  };

  const fetchBackupPreview = async (includeAdmins = false) => {
    try {
      setBackupPreviewLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${baseUrl}admin/user-data-backup/preview?includeAdmins=${includeAdmins}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setBackupPreview(response.data.data);
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.msg || "Failed to load backup preview",
        "error"
      );
    } finally {
      setBackupPreviewLoading(false);
    }
  };

  const downloadUserDataBackup = async (includeAdmins = false) => {
    try {
      setBackupDownloading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${baseUrl}admin/user-data-backup/download?includeAdmins=${includeAdmins}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
          timeout: 600000,
        }
      );

      const disposition = response.headers["content-disposition"] || "";
      const match = /filename="?([^";]+)"?/i.exec(disposition);
      const filename = match ? match[1].trim() : "Ludoflix-user-data-backup.json.gz";

      const blob = new Blob([response.data], { type: "application/gzip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Backup downloaded",
        text: filename,
        timer: 3000,
        showConfirmButton: false,
      });
    } catch (error) {
      let msg = error.response?.data?.msg || error.message || "Download failed";
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const parsed = JSON.parse(text);
          if (parsed.msg) msg = parsed.msg;
        } catch {
          /* ignore */
        }
      }
      Swal.fire("Backup failed", msg, "error");
    } finally {
      setBackupDownloading(false);
    }
  };

  const previewWalletImport = async () => {
    if (!importWalletFile) {
      Swal.fire("Select file", "Choose a backup JSON or .json.gz file first.", "warning");
      return;
    }
    try {
      setImportWalletPreviewLoading(true);
      const token = localStorage.getItem("token");
      const form = new FormData();
      form.append("file", importWalletFile);
      form.append("includeAdmins", "false");
      const response = await axios.post(
        `${baseUrl}admin/user-data-backup/import-wallet/preview`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          timeout: 600000,
        }
      );
      if (response.data.success) {
        setImportWalletPreview(response.data.data);
      }
    } catch (error) {
      Swal.fire(
        "Import preview failed",
        error.response?.data?.msg || error.message || "Request failed",
        "error"
      );
    } finally {
      setImportWalletPreviewLoading(false);
    }
  };

  const applyWalletImport = async () => {
    if (!importWalletFile) {
      Swal.fire("Select file", "Choose a backup JSON or .json.gz file first.", "warning");
      return;
    }

    const { value: typed } = await Swal.fire({
      title: "Import wallet & referrals",
      html: `
        <p style="text-align:left;margin:0 0 12px;font-size:14px;line-height:1.5">
          Restores all users with valid phone from backup. Referral code, parent link, referral wallet,
          earnings and stats for everyone (wallet or not). Main wallet only if balance is above ₹50.
          Existing users get referral fields updated. Login is OTP on phone.
        </p>
        <p style="text-align:left;margin:0;font-size:13px;color:#b45309">
          Type <strong>${IMPORT_WALLET_CONFIRM_PHRASE}</strong> to confirm:
        </p>
      `,
      input: "text",
      inputPlaceholder: IMPORT_WALLET_CONFIRM_PHRASE,
      showCancelButton: true,
      confirmButtonText: "Apply import",
      confirmButtonColor: "#dc2626",
    });

    if (!typed || typed.trim() !== IMPORT_WALLET_CONFIRM_PHRASE) return;

    try {
      setImportWalletApplying(true);
      const token = localStorage.getItem("token");
      const form = new FormData();
      form.append("file", importWalletFile);
      form.append("includeAdmins", "false");
      form.append("confirmPhrase", IMPORT_WALLET_CONFIRM_PHRASE);
      const response = await axios.post(
        `${baseUrl}admin/user-data-backup/import-wallet/apply`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          timeout: 600000,
        }
      );
      if (response.data.success) {
        const d = response.data.data || {};
        Swal.fire({
          icon: "success",
          title: "Import complete",
          html: `
            Users created: <b>${d.created ?? 0}</b><br/>
            Referral updated (existing): <b>${d.updatedExisting ?? 0}</b><br/>
            Wallet (balance &gt; ₹50): <b>${d.walletCreated ?? d.walletUpdated ?? 0}</b><br/>
            Referral-only (new): <b>${d.referralOnlyCreated ?? 0}</b><br/>
            Referred-by links: <b>${d.referredBy?.linked ?? 0}</b><br/>
            Invalid phone (skipped): <b>${d.skippedNotEligible ?? 0}</b><br/>
            Ledger synced: <b>${d.ledgerSync?.synced ?? 0}</b>
          `,
        });
        setImportWalletPreview(null);
        setImportWalletFile(null);
        if (importWalletFileRef.current) importWalletFileRef.current.value = "";
      }
    } catch (error) {
      Swal.fire(
        "Import failed",
        error.response?.data?.msg || error.message || "Request failed",
        "error"
      );
    } finally {
      setImportWalletApplying(false);
    }
  };

  const syncImportedWalletLedger = async () => {
    try {
      setLedgerSyncLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${baseUrl}admin/user-data-backup/sync-wallet-ledger`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        const d = response.data.data || {};
        Swal.fire({
          icon: "success",
          title: "Ledger synced",
          html: `
            Users checked: <b>${d.checked ?? 0}</b><br/>
            Ledger fixed: <b>${d.synced ?? 0}</b><br/>
            Already OK: <b>${d.alreadyOk ?? 0}</b><br/>
            <small>Wallet amounts were not reduced.</small>
          `,
        });
      }
    } catch (error) {
      Swal.fire(
        "Sync failed",
        error.response?.data?.msg || error.message || "Request failed",
        "error"
      );
    } finally {
      setLedgerSyncLoading(false);
    }
  };

  const repairNegativeLedgerMismatch = async () => {
    const ok = await Swal.fire({
      icon: "warning",
      title: "Fix minus mismatch (all users)?",
      html:
        "Users jinka wallet ledger se kam hai (minus mismatch), unka ledger adjust hoga. " +
        "<strong>Wallet balance change nahi hogi.</strong> " +
        "Purani winning→deposit conversion bug ke baad use karein.",
      showCancelButton: true,
      confirmButtonText: "Repair all",
    });
    if (!ok.isConfirmed) return;
    try {
      setNegativeLedgerRepairLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${baseUrl}admin/wallet/repair-negative-ledger`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        const d = response.data.data || {};
        Swal.fire({
          icon: "success",
          title: "Minus mismatch repaired",
          html: `
            Users checked: <b>${d.checked ?? 0}</b><br/>
            Repaired: <b>${d.repaired ?? 0}</b><br/>
            Already OK: <b>${d.alreadyOk ?? 0}</b><br/>
            <small>Wallet amounts unchanged.</small>
          `,
        });
      }
    } catch (error) {
      Swal.fire(
        "Repair failed",
        error.response?.data?.msg || error.message || "Request failed",
        "error"
      );
    } finally {
      setNegativeLedgerRepairLoading(false);
    }
  };

  const toggleFakeBattle = async () => {
    try {
      setFakeBattleLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(baseUrl + "admin/fake-battle/toggle", 
        { enabled: !fakeBattleEnabled },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.success) {
        setFakeBattleEnabled(response.data.enabled);
        Swal.fire({
          icon: "success",
          title: response.data.enabled ? "Fake open battles ON" : "Fake open battles OFF",
          text: response.data.enabled
            ? "Fake open battles and feed decoys will show in the app."
            : "Fake open battles hidden. Running-tab setting is unchanged.",
          timer: 2000,
          showConfirmButton: false
        });
        fetchFakeBattleStatus();
      }
    } catch (error) {
      Swal.fire("Error", "Failed to toggle fake open battles", "error");
    } finally {
      setFakeBattleLoading(false);
    }
  };

  const toggleFakeRunningBattle = async () => {
    try {
      setFakeRunningBattleLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        baseUrl + "admin/fake-running-battle/toggle",
        { enabled: !fakeRunningBattleEnabled },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        setFakeRunningBattleEnabled(Boolean(response.data.runningEnabled));
        Swal.fire({
          icon: "success",
          title: response.data.runningEnabled
            ? "Fake running battles ON"
            : "Fake running battles OFF",
          text: response.data.runningEnabled
            ? "Running-tab decoys will show after users refresh."
            : "Running-tab decoys hidden. Open-battle setting is unchanged.",
          timer: 2000,
          showConfirmButton: false
        });
        fetchFakeBattleStatus();
      } else {
        Swal.fire(
          "Error",
          response.data?.msg || "Failed to toggle fake running battles",
          "error"
        );
      }
    } catch (error) {
      const msg =
        error.response?.data?.msg ||
        error.response?.data?.message ||
        "Failed to toggle fake running battles";
      Swal.fire("Error", msg, "error");
    } finally {
      setFakeRunningBattleLoading(false);
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(baseUrl + "settings/data");
        const data = res.data;
        setSettings(prev => ({
          ...prev,
          settingId: data._id || '',
          WebTitle: data.WebTitle || '',
          WebsiteName: data.WebsiteName || '',
          CompanyName: data.CompanyName || '',
          CompanyAddress: data.CompanyAddress || '',
          CompanyMobile: data.CompanyMobile || '',
          CompanyEmail: data.CompanyEmail || '',
          CompanyWebsite: data.CompanyWebsite || '',
          telegramUsername: data.telegramUsername || '',
          Logo: data.Logo || '',
          SmallLogo: data.SmallLogo || '',
          LandingImage1: data.LandingImage1 || '',
          LandingImage2: data.LandingImage2 || '',
          LandingImage3: data.LandingImage3 || '',
          LandingImage4: data.LandingImage4 || '',
          isLandingImage1: data.isLandingImage1 !== false,
          isLandingImage2: data.isLandingImage2 !== false,
          isLandingImage3: data.isLandingImage3 !== false,
          isLandingImage4: data.isLandingImage4 !== false,
          version: data.version || '',
          DepositNotice: data.DepositNotice || '',
          WithdrawNotice: data.WithdrawNotice || '',
          HomepageNotice: data.HomepageNotice || '',
          MainpageNotice: data.MainpageNotice || '',
          isDepositNoticeActive: data.isDepositNoticeActive ?? true,
          isWithdrawNoticeActive: data.isWithdrawNoticeActive ?? true,
          isHomepageNoticeActive: data.isHomepageNoticeActive ?? true,
          isMainpageNoticeActive: data.isMainpageNoticeActive ?? true,
          isMaintenanceMode: data.isMaintenanceMode ?? false,
          MaintenanceMessage: data.MaintenanceMessage || "Website is under maintenance. Please try again later.",
          newRegistrationEnabled: data.newRegistrationEnabled !== false,
          newRegistrationClosedMessage: data.newRegistrationClosedMessage || "",
          minDepositAmt: data.minDepositAmt || "",
          minFirstDepositForWithdraw:
            data.minFirstDepositForWithdraw != null
              ? String(data.minFirstDepositForWithdraw)
              : "300",
          minWithdrawAmtUPI: data.minWithdrawAmtUPI || "",
          minWithdrawAmtBank: data.minWithdrawAmtBank || "",
          minBetAmt: data.minBetAmt || "",
          maxBetAmt: data.maxBetAmt || "",
          adminCommissionPct: data.adminCommissionPct ?? "",
          referralCommissionPct: data.referralCommissionPct ?? "",
          withdrawCashbackEnabled:
            data.withdrawCashbackEnabled !== false &&
            data.withdrawCashbackEnabled !== "false",
          withdrawCashbackPercent:
            data.withdrawCashbackPercent != null && Number(data.withdrawCashbackPercent) > 0
              ? String(data.withdrawCashbackPercent)
              : "2",
          withdrawCooldownHours:
            data.withdrawCooldownHours != null
              ? String(data.withdrawCooldownHours)
              : "3",
          userWithdrawCancelEnabled:
            data.userWithdrawCancelEnabled !== false &&
            data.userWithdrawCancelEnabled !== "false",
          signupBonusAmount:
            data.signupBonusAmount != null ? String(data.signupBonusAmount) : "10",
          aadhaarOtpKycEnabled: Boolean(data.aadhaarOtpKycEnabled),
          aadhaarManualKycEnabled: data.aadhaarManualKycEnabled !== false,
          kycRequiredForPlay: Boolean(data.kycRequiredForPlay),
          ludoKingApiEnabled: Boolean(data.ludoKingApiEnabled),
          ludoRichGameEnabled: Boolean(data.ludoRichGameEnabled),
          ludoRichMinBetAmt:
            data.ludoRichMinBetAmt != null ? String(data.ludoRichMinBetAmt) : "",
          ludoRichMaxBetAmt:
            data.ludoRichMaxBetAmt != null ? String(data.ludoRichMaxBetAmt) : "",
        }));
      } catch {
        Swal.fire("Error", "Failed to load settings", "error");
      }
    };
    fetchSettings();
    fetchFakeBattleStatus();
    
    const interval = setInterval(fetchFakeBattleStatus, 10000);
    return () => clearInterval(interval);
  }, [baseUrl]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleLogoChange = (e) => {
    const { name, files } = e.target;
    if (files?.[0]) {
      setSettings(prev => ({ ...prev, [name]: files[0] }));
    }
  };

  const handleLandingImageChange = (e) => {
    const { name, files } = e.target;
    if (files?.[0]) {
      setSettings((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  const removeLogo = (fieldName) => {
    setSettings(prev => ({ ...prev, [fieldName]: "" }));
    if (fileRefs[fieldName].current) fileRefs[fieldName].current.value = '';
  };

  const removeLandingImagePick = (fieldName) => {
    setSettings((prev) => {
      const current = prev[fieldName];
      if (current instanceof File) {
        return { ...prev, [fieldName]: "" };
      }
      return prev;
    });
    if (fileRefs[fieldName]?.current) fileRefs[fieldName].current.value = "";
  };

  const buildAssetUrl = (asset) => {
    if (!asset || asset instanceof File) return null;
    const base = String(baseUrl || "").replace(/\/$/, "");
    const path = String(asset).replace(/^\//, "");
    return `${base}/${path}`;
  };

  const buildLogoUrl = (logo) => buildAssetUrl(logo);

  const saveLogos = async () => {
    if (!settings.settingId) {
      Swal.fire("Error", "Settings not loaded. Refresh the page.", "error");
      return;
    }
    const hasLogoFile = settings.Logo instanceof File;
    const hasSmallFile = settings.SmallLogo instanceof File;
    if (!hasLogoFile && !hasSmallFile) {
      Swal.fire("Info", "Select a logo image first, then click Save Logos.", "info");
      return;
    }

    try {
      setLogoLoading(true);
      const formData = new FormData();
      if (hasLogoFile) formData.append("Logo", settings.Logo);
      if (hasSmallFile) formData.append("SmallLogo", settings.SmallLogo);
      formData.append("settingId", settings.settingId);

      const response = await axios.post(baseUrl + "settings/logos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        const updated = response.data.data || {};
        setSettings((prev) => ({
          ...prev,
          Logo: updated.Logo || prev.Logo,
          SmallLogo: updated.SmallLogo || prev.SmallLogo,
        }));
        if (fileRefs.Logo.current) fileRefs.Logo.current.value = "";
        if (fileRefs.SmallLogo.current) fileRefs.SmallLogo.current.value = "";
        Swal.fire("Success", "Logos updated!", "success");
      } else {
        Swal.fire("Error", response.data?.message || "Failed to update logos", "error");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Error updating logos";
      Swal.fire("Error", msg, "error");
    } finally {
      setLogoLoading(false);
    }
  };

  const saveLandingImages = async () => {
    if (!settings.settingId) {
      Swal.fire("Error", "Settings not loaded. Refresh the page.", "error");
      return;
    }

    const hasFile =
      settings.LandingImage1 instanceof File ||
      settings.LandingImage2 instanceof File;

    try {
      setLandingImageLoading(true);
      const formData = new FormData();
      formData.append("settingId", settings.settingId);
      formData.append("isLandingImage1", settings.isLandingImage1 ? "true" : "false");
      formData.append("isLandingImage2", settings.isLandingImage2 ? "true" : "false");

      if (settings.LandingImage1 instanceof File) {
        formData.append("LandingImage1", settings.LandingImage1);
      }
      if (settings.LandingImage2 instanceof File) {
        formData.append("LandingImage2", settings.LandingImage2);
      }

      const response = await axios.post(baseUrl + "settings/landing-images", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        const updated = response.data.data || {};
        setSettings((prev) => ({
          ...prev,
          LandingImage1: updated.LandingImage1 || prev.LandingImage1,
          LandingImage2: updated.LandingImage2 || prev.LandingImage2,
          isLandingImage1: updated.isLandingImage1 !== false,
          isLandingImage2: updated.isLandingImage2 !== false,
        }));
        if (fileRefs.LandingImage1.current) fileRefs.LandingImage1.current.value = "";
        if (fileRefs.LandingImage2.current) fileRefs.LandingImage2.current.value = "";
        Swal.fire("Success", "Landing game images updated!", "success");
      } else {
        Swal.fire("Error", response.data?.message || "Failed to update landing images", "error");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Error updating landing images";
      Swal.fire("Error", msg, "error");
    } finally {
      setLandingImageLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      Object.keys(settings).forEach(key => {
        const skipFile =
          key === "Logo" ||
          key === "SmallLogo" ||
          key === "LandingImage1" ||
          key === "LandingImage2" ||
          key === "LandingImage3" ||
          key === "LandingImage4";
        if (!skipFile) {
          formData.append(key, settings[key]);
        }
      });
      const response = await axios.post(baseUrl + "settings", formData);
      if (response.data.status === 'success') {
        Swal.fire("Success", "Settings updated!", "success");
      } else {
        Swal.fire("Error", "Failed to update", "error");
      }
    } catch {
      Swal.fire("Error", "Error updating", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-content settings-container">
      <div className="page-header mb-3">
        <h4 className="text-uppercase font-weight-bold mb-1">Website Settings</h4>
        <p className="page-subtitle">
          Quick toggles at the top · tabbed sections below · Save all settings at the bottom
        </p>
      </div>
      
      <div className="fake-battle-grid">
        <div className="fake-battle-card">
        <div className="fake-battle-header">
          <div className="fake-battle-title">
            <span>🎯</span> Fake open battles
          </div>
          <div className="toggle-switch">
            <span className="toggle-label">{fakeBattleEnabled ? "Enabled" : "Disabled"}</span>
            <button
              className={`toggle-btn ${fakeBattleEnabled ? "enabled" : "disabled"}`}
              onClick={toggleFakeBattle}
              disabled={fakeBattleLoading}
            />
          </div>
        </div>
        <p style={{ margin: "12px 20px 0", fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>
          OFF: fake open battles and feed decoys stop (server scheduler). Running tab is not affected.
        </p>

        <div className="fake-battle-stats">
          <div className="stat-item">
            <span className="stat-value">{fakeBattleStatus.activeCount}</span>
            <span className="stat-label">Active</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{fakeBattleStatus.currentLargeBattles}/{fakeBattleStatus.maxLargeBattles}</span>
            <span className="stat-label">Large Battles</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{fakeBattleStatus.burstMode ? "🔥" : "❄️"}</span>
            <span className="stat-label">Burst Mode</span>
          </div>
        </div>
        
        <div className="battle-badges">
          <span className="badge badge-flash">⚡ Flash: {fakeBattleStatus.battleTypeBreakdown?.flash3s || 0}</span>
          <span className="badge badge-ten">⏱️ 10s: {fakeBattleStatus.battleTypeBreakdown?.tenSeconds || 0}</span>
          <span className="badge badge-high">💰 High: {fakeBattleStatus.battleTypeBreakdown?.highValue || 0}</span>
          <span className="badge badge-regular">📌 Regular: {fakeBattleStatus.battleTypeBreakdown?.regular || 0}</span>
        </div>
        </div>

        <div className="fake-battle-card fake-battle-card--running">
          <div className="fake-battle-header">
            <div className="fake-battle-title">
              <span>🏃</span> Fake running battles
            </div>
            <div className="toggle-switch">
              <span className="toggle-label">
                {fakeRunningBattleEnabled ? "Enabled" : "Disabled"}
              </span>
              <button
                className={`toggle-btn ${fakeRunningBattleEnabled ? "enabled" : "disabled"}`}
                onClick={toggleFakeRunningBattle}
                disabled={fakeRunningBattleLoading}
              />
            </div>
          </div>
          <p style={{ margin: "12px 20px 16px", fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>
            OFF: running-tab decoy cards only. Open battles stay as set in the left toggle.
            Users refresh the app to see the change.
          </p>
        </div>
      </div>

      {isAdmin && !backupToolsOpen && (
        <div className="backup-zone-collapsed">
          <button
            type="button"
            className="btn-backup-toggle"
            onClick={() => setBackupToolsOpen(true)}
          >
            User data backup &amp; restore — click to open
          </button>
        </div>
      )}

      {isAdmin && backupToolsOpen && (
        <div className="backup-zone-card">
          <div className="backup-zone-header">
            <div className="backup-zone-header-row">
              <h3 className="backup-zone-title">User data backup</h3>
              <button
                type="button"
                className="btn-backup-hide"
                onClick={() => setBackupToolsOpen(false)}
              >
                Hide
              </button>
            </div>
          </div>
          <div className="backup-zone-body">
            <p className="backup-zone-desc">
              Download a compressed JSON backup of all users (wallet, referral codes, profiles) plus
              transactions, games, KYC, referral history, spins, and related records.
              Passwords and login tokens are redacted.
            </p>

            {backupPreview && (
              <div className="purge-preview-box">
                <div>
                  Users: <strong>{backupPreview.usersCount}</strong>
                  {" · "}
                  Total documents: <strong>{backupPreview.totalDocuments}</strong>
                </div>
                <ul style={{ margin: "8px 0 0", paddingLeft: "18px" }}>
                  <li>users: {backupPreview.usersCount}</li>
                  {Object.entries(backupPreview.collectionCounts || {}).map(([label, n]) =>
                    n > 0 ? (
                      <li key={label}>
                        {label}: {n}
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            )}

            <div className="backup-actions">
              <button
                type="button"
                className="btn-backup-outline"
                disabled={backupPreviewLoading || backupDownloading}
                onClick={() => fetchBackupPreview(false)}
              >
                {backupPreviewLoading ? "Loading…" : "Preview counts"}
              </button>
              <button
                type="button"
                className="btn-backup-solid"
                disabled={backupDownloading}
                onClick={() => downloadUserDataBackup(false)}
              >
                {backupDownloading ? "Preparing download…" : "Download backup (.json.gz)"}
              </button>
            </div>
            <hr style={{ margin: "20px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

            <p className="backup-zone-desc" style={{ marginTop: 0 }}>
              <strong>Restore users from backup</strong> — JSON (<code>.json</code> or <code>.gz</code>).
              All users with valid phone: <strong>referral code</strong>, <strong>referral</strong> (parent),
              <strong>referral_wallet</strong>, <strong>referral_earning</strong>, <strong>referral_stats</strong>.
              Main <strong>Wallet_balance</strong> only if above ₹50. Existing users: referral fields updated.
              After import use <strong>Fix wallet mismatch</strong> if needed. Login is OTP.
            </p>

            <input
              ref={importWalletFileRef}
              type="file"
              accept=".json,.gz,application/json,application/gzip"
              style={{ marginBottom: 12, maxWidth: "100%" }}
              onChange={(e) => {
                const file = e.target.files?.[0] || null;
                setImportWalletFile(file);
                setImportWalletPreview(null);
              }}
            />
            {importWalletFile && (
              <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 12px" }}>
                Selected: <strong>{importWalletFile.name}</strong> (
                {(importWalletFile.size / (1024 * 1024)).toFixed(2)} MB)
              </p>
            )}

            {importWalletPreview && (
              <div className="purge-preview-box">
                <div>
                  Backup users: <strong>{importWalletPreview.backupUsersCount}</strong>
                  {" · "}
                  Will create: <strong>{importWalletPreview.toCreate ?? importWalletPreview.matched ?? 0}</strong>
                  {" · "}
                  Will update referral: <strong>{importWalletPreview.toUpdateReferral ?? importWalletPreview.alreadyInDb ?? 0}</strong>
                </div>
                <div style={{ marginTop: 8 }}>
                  Wallet (balance &gt; ₹50): <strong>{importWalletPreview.walletUsers ?? importWalletPreview.walletWillUpdate ?? 0}</strong>
                  {" · "}
                  Referral-only (no wallet): <strong>{importWalletPreview.referralOnlyUsers ?? 0}</strong>
                  {" · "}
                  With referral parent: <strong>{importWalletPreview.withReferralParent ?? 0}</strong>
                  {" · "}
                  Invalid phone: <strong>{importWalletPreview.skippedNotEligible ?? 0}</strong>
                </div>
                <div style={{ marginTop: 8 }}>
                  Wallet total (eligible): <strong>₹{importWalletPreview.walletTotalEligible ?? 0}</strong>
                  {" · "}
                  Referral wallet total: <strong>₹{importWalletPreview.referralWalletTotalFromBackup ?? 0}</strong>
                </div>
              </div>
            )}

            <div className="backup-actions">
              <button
                type="button"
                className="btn-backup-outline"
                disabled={importWalletPreviewLoading || importWalletApplying || !importWalletFile}
                onClick={previewWalletImport}
              >
                {importWalletPreviewLoading ? "Analyzing…" : "Preview import"}
              </button>
              <button
                type="button"
                className="btn-backup-solid"
                style={{ background: "#dc2626" }}
                disabled={importWalletApplying || !importWalletFile || !importWalletPreview}
                onClick={applyWalletImport}
              >
                {importWalletApplying ? "Importing…" : "Apply import"}
              </button>
              <button
                type="button"
                className="btn-backup-outline"
                disabled={ledgerSyncLoading}
                onClick={syncImportedWalletLedger}
                title="Wallet > ledger (plus mismatch) — keeps wallet, adjusts ledger"
              >
                {ledgerSyncLoading ? "Syncing ledger…" : "Fix plus mismatch (all users)"}
              </button>
              <button
                type="button"
                className="btn-backup-outline"
                disabled={negativeLedgerRepairLoading}
                onClick={repairNegativeLedgerMismatch}
                title="Wallet < ledger (minus mismatch) — e.g. old winning→deposit bug"
              >
                {negativeLedgerRepairLoading
                  ? "Repairing…"
                  : "Fix minus mismatch (all users)"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="settings-card">
        <form onSubmit={handleSubmit} className="settings-form-inner">
          <div className="ss-quick-bar">
            <div className="ss-quick-bar__head">
              <div>
                <h2 className="ss-quick-bar__title">Quick controls</h2>
                <p className="ss-quick-bar__hint">
                  Toggle important options here, then open a tab below for details. Click Save at the bottom.
                </p>
              </div>
            </div>
            <div className="ss-quick-grid">
              <QuickToggleCard
                name="newRegistrationEnabled"
                checked={settings.newRegistrationEnabled}
                onChange={handleChange}
                label="New user registration"
              />
              <QuickToggleCard
                name="isMaintenanceMode"
                checked={settings.isMaintenanceMode}
                onChange={handleChange}
                label="Maintenance mode"
              />
              <QuickToggleCard
                name="kycRequiredForPlay"
                checked={settings.kycRequiredForPlay}
                onChange={handleChange}
                label="KYC required to play"
              />
              <QuickToggleCard
                name="ludoKingApiEnabled"
                checked={settings.ludoKingApiEnabled}
                onChange={handleChange}
                label="Ludo King auto API"
              />
            </div>
          </div>

          <div className="ss-tabs-wrap" role="tablist">
            {SETTINGS_TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`ss-tab-btn ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="settings-content">
            <TabPanel id="general" activeTab={activeTab}>
            <div className="ss-panel">
              <h2 className="section-title">Basic Information</h2>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Website Title</label>
                  <input
                    className="form-input"
                    type="text"
                    name="WebTitle"
                    value={settings.WebTitle}
                    onChange={handleChange}
                    placeholder="Enter website title"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Website Name</label>
                  <input
                    className="form-input"
                    type="text"
                    name="WebsiteName"
                    value={settings.WebsiteName}
                    onChange={handleChange}
                    placeholder="Enter website name"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Company Name</label>
                  <input
                    className="form-input"
                    type="text"
                    name="CompanyName"
                    value={settings.CompanyName}
                    onChange={handleChange}
                    placeholder="Enter company name"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Version</label>
                  <input
                    className="form-input"
                    type="text"
                    name="version"
                    value={settings.version}
                    onChange={handleChange}
                    placeholder="Enter version"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Company Address</label>
                  <input
                    className="form-input"
                    type="text"
                    name="CompanyAddress"
                    value={settings.CompanyAddress}
                    onChange={handleChange}
                    placeholder="Enter company address"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Company Mobile</label>
                  <input
                    className="form-input"
                    type="text"
                    name="CompanyMobile"
                    value={settings.CompanyMobile}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                  />
                </div>
              </div>
            </div>

            <div className="ss-panel">
              <h2 className="section-title">Contact Details</h2>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Company Email</label>
                  <input
                    className="form-input"
                    type="email"
                    name="CompanyEmail"
                    value={settings.CompanyEmail}
                    onChange={handleChange}
                    placeholder="Enter email address"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Company Website</label>
                  <input
                    className="form-input"
                    type="url"
                    name="CompanyWebsite"
                    value={settings.CompanyWebsite}
                    onChange={handleChange}
                    placeholder="Enter website URL"
                  />
                </div>

                <div className="form-group grid-span-full">
                  <label className="form-label">Telegram username (Landing page)</label>
                  <input
                    className="form-input"
                    type="text"
                    name="telegramUsername"
                    value={settings.telegramUsername}
                    onChange={handleChange}
                    placeholder="e.g. Ludoflix_premimum_gaming (no @)"
                  />
                  <small className="text-muted">
                    Public channel or group username only (no https://). Opens as https://t.me/username on the app landing page.
                  </small>
                </div>
              </div>
            </div>

            <div className="ss-panel logo-section">
              <h2 className="section-title">Logos</h2>
              <div className="logo-grid">
                <div className="form-group">
                  <label className="logo-label">Main Logo</label>
                  <div className="logo-upload">
                    <label htmlFor="logo-upload" className="logo-upload-btn">
                      Upload Logo
                    </label>
                    <input
                      id="logo-upload"
                      ref={fileRefs.Logo}
                      type="file"
                      name="Logo"
                      onChange={handleLogoChange}
                      accept="image/*"
                    />
                  </div>
                  {(settings.Logo instanceof File || buildLogoUrl(settings.Logo)) && (
                    <div style={{ marginTop: 10 }}>
                      <img
                        alt="Main logo preview"
                        src={
                          settings.Logo instanceof File
                            ? URL.createObjectURL(settings.Logo)
                            : buildLogoUrl(settings.Logo)
                        }
                        style={{ maxHeight: 56, maxWidth: "100%", objectFit: "contain" }}
                      />
                    </div>
                  )}
                  {settings.Logo && (
                    <button type="button" className="logo-remove" onClick={() => removeLogo("Logo")}>
                      Remove Logo
                    </button>
                  )}
                </div>

                <div className="form-group">
                  <label className="logo-label">Small Logo</label>
                  <div className="logo-upload">
                    <label htmlFor="small-logo-upload" className="logo-upload-btn">
                      Upload Small Logo
                    </label>
                    <input
                      id="small-logo-upload"
                      ref={fileRefs.SmallLogo}
                      type="file"
                      name="SmallLogo"
                      onChange={handleLogoChange}
                      accept="image/*"
                    />
                  </div>
                  {(settings.SmallLogo instanceof File || buildLogoUrl(settings.SmallLogo)) && (
                    <div style={{ marginTop: 10 }}>
                      <img
                        alt="Small logo preview"
                        src={
                          settings.SmallLogo instanceof File
                            ? URL.createObjectURL(settings.SmallLogo)
                            : buildLogoUrl(settings.SmallLogo)
                        }
                        style={{ maxHeight: 48, maxWidth: "100%", objectFit: "contain" }}
                      />
                    </div>
                  )}
                  {settings.SmallLogo && (
                    <button type="button" className="logo-remove" onClick={() => removeLogo("SmallLogo")}>
                      Remove Logo
                    </button>
                  )}
                </div>
              </div>

              <button
                type="button"
                className="btn-secondary"
                onClick={saveLogos}
                disabled={
                  logoLoading ||
                  (!(settings.Logo instanceof File) && !(settings.SmallLogo instanceof File))
                }
                style={{ marginTop: 16 }}
              >
                {logoLoading ? (
                  <>
                    <div className="spinner" />
                    Uploading...
                  </>
                ) : (
                  "Save Logos"
                )}
              </button>
            </div>
            </TabPanel>

            <TabPanel id="kyc" activeTab={activeTab}>
            <div className="ss-panel">
              <h2 className="section-title">KYC</h2>
              <div className="form-group">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="aadhaarOtpKycEnabled"
                      checked={settings.aadhaarOtpKycEnabled}
                      onChange={handleChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <span className="switch-label">Enable Aadhaar OTP KYC (APITxt API)</span>
                </div>
                <div className="switch-container" style={{ marginTop: 12 }}>
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="aadhaarManualKycEnabled"
                      checked={settings.aadhaarManualKycEnabled}
                      onChange={handleChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <span className="switch-label">Enable manual Aadhaar KYC (photo upload)</span>
                </div>
                <small className="text-muted">
                  OTP: APITxt (APITXT_AUTH_KEY). Manual: photo upload. At least one should be ON.
                  One Aadhaar per account — duplicates are blocked.
                </small>
                <div className="switch-container" style={{ marginTop: 12 }}>
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="kycRequiredForPlay"
                      checked={settings.kycRequiredForPlay}
                      onChange={handleChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <span className="switch-label">Require KYC to play games</span>
                </div>
                <small className="text-muted">
                  ON: unverified users cannot create or join battles until KYC is complete.
                </small>
              </div>
            </div>

            <div className="ss-panel">
              <h2 className="section-title">Battles — Ludo King API</h2>
              <div className="form-group">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="ludoKingApiEnabled"
                      checked={settings.ludoKingApiEnabled}
                      onChange={handleChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <span className="switch-label">Enable Ludo King room check &amp; auto result API</span>
                </div>
              </div>
            </div>
            </TabPanel>

            <TabPanel id="money" activeTab={activeTab}>
            <div className="ss-panel logo-section">
              <h2 className="section-title">Landing page — game images</h2>
              <p className="text-muted" style={{ marginBottom: 16 }}>
                Images shown on the app landing page under <strong>Our Games</strong>. Recommended: wide card ratio (~16:9), JPG or PNG.
              </p>
              <div className="logo-grid">
                <div className="form-group">
                  <label className="logo-label">Ludo Classics Lite (card 1)</label>
                  <div className="switch-container" style={{ marginBottom: 10 }}>
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isLandingImage1"
                        checked={settings.isLandingImage1}
                        onChange={handleChange}
                      />
                      <span className="slider" />
                    </label>
                    <span className="switch-label">Use custom image (off = default built-in)</span>
                  </div>
                  <div className="logo-upload">
                    <label htmlFor="landing-image-1" className="logo-upload-btn">
                      Upload image
                    </label>
                    <input
                      id="landing-image-1"
                      ref={fileRefs.LandingImage1}
                      type="file"
                      name="LandingImage1"
                      onChange={handleLandingImageChange}
                      accept="image/*"
                    />
                  </div>
                  {(settings.LandingImage1 instanceof File || buildAssetUrl(settings.LandingImage1)) && (
                    <div className="landing-game-preview">
                      <img
                        alt="Ludo Classics Lite preview"
                        src={
                          settings.LandingImage1 instanceof File
                            ? URL.createObjectURL(settings.LandingImage1)
                            : buildAssetUrl(settings.LandingImage1)
                        }
                      />
                    </div>
                  )}
                  {settings.LandingImage1 instanceof File && (
                    <button
                      type="button"
                      className="logo-remove"
                      onClick={() => removeLandingImagePick("LandingImage1")}
                    >
                      Clear selected file
                    </button>
                  )}
                </div>

                <div className="form-group">
                  <label className="logo-label">Ludo Classics Rich (card 2)</label>
                  <div className="switch-container" style={{ marginBottom: 10 }}>
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isLandingImage2"
                        checked={settings.isLandingImage2}
                        onChange={handleChange}
                      />
                      <span className="slider" />
                    </label>
                    <span className="switch-label">Use custom image (off = default built-in)</span>
                  </div>
                  <div className="logo-upload">
                    <label htmlFor="landing-image-2" className="logo-upload-btn">
                      Upload image
                    </label>
                    <input
                      id="landing-image-2"
                      ref={fileRefs.LandingImage2}
                      type="file"
                      name="LandingImage2"
                      onChange={handleLandingImageChange}
                      accept="image/*"
                    />
                  </div>
                  {(settings.LandingImage2 instanceof File || buildAssetUrl(settings.LandingImage2)) && (
                    <div className="landing-game-preview">
                      <img
                        alt="Ludo Classics Rich preview"
                        src={
                          settings.LandingImage2 instanceof File
                            ? URL.createObjectURL(settings.LandingImage2)
                            : buildAssetUrl(settings.LandingImage2)
                        }
                      />
                    </div>
                  )}
                  {settings.LandingImage2 instanceof File && (
                    <button
                      type="button"
                      className="logo-remove"
                      onClick={() => removeLandingImagePick("LandingImage2")}
                    >
                      Clear selected file
                    </button>
                  )}
                </div>
              </div>

              <button
                type="button"
                className="btn-secondary"
                onClick={saveLandingImages}
                disabled={landingImageLoading}
                style={{ marginTop: 16 }}
              >
                {landingImageLoading ? (
                  <>
                    <div className="spinner" />
                    Uploading...
                  </>
                ) : (
                  "Save landing game images"
                )}
              </button>
            </div>

            <div className="ss-panel">
              <h2 className="section-title">Financial Limits</h2>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Minimum Deposit Amount</label>
                  <input
                    className="form-input"
                    type="number"
                    name="minDepositAmt"
                    value={settings.minDepositAmt}
                    onChange={handleChange}
                    placeholder="Enter minimum deposit"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Min deposit for withdrawal unlock (₹)</label>
                  <input
                    className="form-input"
                    type="number"
                    min="0"
                    name="minFirstDepositForWithdraw"
                    value={settings.minFirstDepositForWithdraw}
                    onChange={handleChange}
                    placeholder="300"
                  />
                  <small className="text-muted">
                    User ka total deposit is amount se kam ho to withdraw nahi kar sakta.
                  </small>
                </div>
                
                <div className="form-group">
                  <label className="form-label">Minimum Bet Amount</label>
                  <input
                    className="form-input"
                    type="number"
                    name="minBetAmt"
                    value={settings.minBetAmt}
                    onChange={handleChange}
                    placeholder="Enter minimum bet"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Maximum Bet Amount</label>
                  <input
                    className="form-input"
                    type="number"
                    name="maxBetAmt"
                    value={settings.maxBetAmt}
                    onChange={handleChange}
                    placeholder="Enter maximum bet"
                  />
                </div>

              </div>

              <h3 className="section-subtitle">Landing — Ludo Classics Rich</h3>
              <div className="form-group">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="ludoRichGameEnabled"
                      checked={settings.ludoRichGameEnabled}
                      onChange={handleChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <span className="switch-label">Enable Ludo Classics Rich on landing (LIVE)</span>
                </div>
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Rich game — minimum bet (₹)</label>
                  <input
                    className="form-input"
                    type="number"
                    min="1"
                    name="ludoRichMinBetAmt"
                    value={settings.ludoRichMinBetAmt}
                    onChange={handleChange}
                    placeholder="Uses global min if empty"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Rich game — maximum bet (₹)</label>
                  <input
                    className="form-input"
                    type="number"
                    min="1"
                    name="ludoRichMaxBetAmt"
                    value={settings.ludoRichMaxBetAmt}
                    onChange={handleChange}
                    placeholder="Uses global max if empty"
                  />
                </div>
              </div>

              <div className="grid-2" style={{ marginTop: 16 }}>
                <div className="form-group">
                  <label className="form-label">Admin Commission (%)</label>
                  <input
                    className="form-input"
                    type="number"
                    step="0.01"
                    min="0"
                    name="adminCommissionPct"
                    value={settings.adminCommissionPct}
                    onChange={handleChange}
                    placeholder="Leave empty for old slab logic"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Referral Commission (%)</label>
                  <input
                    className="form-input"
                    type="number"
                    step="0.01"
                    min="0"
                    name="referralCommissionPct"
                    value={settings.referralCommissionPct}
                    onChange={handleChange}
                    placeholder="Default 3"
                  />
                </div>

                <div className="form-group grid-span-full">
                  <div className="ss-toggle-row">
                    <span className="ss-toggle-row__label">
                      Allow users to cancel pending withdrawals (after 1 hour)
                    </span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="userWithdrawCancelEnabled"
                        checked={Boolean(settings.userWithdrawCancelEnabled)}
                        onChange={handleChange}
                      />
                      <span className="slider" />
                    </label>
                  </div>
                  <small className="text-muted">
                    OFF = no Cancel button in app. ON = Cancel shows after 1 hour in pending queue.
                  </small>
                </div>

                <div className="form-group">
                  <label className="form-label">Withdraw cooldown (hours)</label>
                  <input
                    className="form-input"
                    type="number"
                    step="0.25"
                    min="0"
                    max="12"
                    name="withdrawCooldownHours"
                    value={settings.withdrawCooldownHours}
                    onChange={handleChange}
                    placeholder="3"
                  />
                  <small className="text-muted">
                    Wait after each successful withdraw. 0 = off. Max 12 hours.
                  </small>
                </div>

                <div className="form-group grid-span-full">
                  <label className="form-label">Withdraw cashback</label>
                  <div className="ss-toggle-row" style={{ marginBottom: 10 }}>
                    <span className="ss-toggle-row__label">
                      Enable cashback on withdraw (deducted from payout, credited on success)
                    </span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="withdrawCashbackEnabled"
                        checked={Boolean(settings.withdrawCashbackEnabled)}
                        onChange={handleChange}
                      />
                      <span className="slider" />
                    </label>
                  </div>
                  <input
                    className="form-input"
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    name="withdrawCashbackPercent"
                    value={settings.withdrawCashbackPercent}
                    onChange={handleChange}
                    placeholder="e.g. 5"
                    disabled={!settings.withdrawCashbackEnabled}
                  />
                 
                </div>

                <div className="form-group">
                  <label className="form-label">Sign-up bonus (₹)</label>
                  <input
                    className="form-input"
                    type="number"
                    min="0"
                    step="1"
                    name="signupBonusAmount"
                    value={settings.signupBonusAmount}
                    onChange={handleChange}
                    placeholder="10"
                  />
                  
                </div>

                <div className="form-group">
                  <label className="form-label">Minimum UPI Withdrawal</label>
                  <input
                    className="form-input"
                    type="number"
                    name="minWithdrawAmtUPI"
                    value={settings.minWithdrawAmtUPI}
                    onChange={handleChange}
                    placeholder="Enter minimum UPI withdrawal"
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Minimum Bank Withdrawal</label>
                  <input
                    className="form-input"
                    type="number"
                    name="minWithdrawAmtBank"
                    value={settings.minWithdrawAmtBank}
                    onChange={handleChange}
                    placeholder="Enter minimum bank withdrawal"
                  />
                </div>
              </div>
            </div>
            </TabPanel>

            <TabPanel id="notices" activeTab={activeTab}>
            <div className="ss-panel">
              <h2 className="section-title">Notices</h2>
              <div className="grid-4">
                <div className="form-group">
                  <label className="form-label">Deposit Notice</label>
                  <textarea
                    className="form-textarea"
                    name="DepositNotice"
                    value={settings.DepositNotice}
                    onChange={handleChange}
                    placeholder="Enter deposit notice"
                  />
                  <div className="switch-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isDepositNoticeActive"
                        checked={settings.isDepositNoticeActive}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className="switch-label">Show Notice</span>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Withdraw Notice</label>
                  <textarea
                    className="form-textarea"
                    name="WithdrawNotice"
                    value={settings.WithdrawNotice}
                    onChange={handleChange}
                    placeholder="Enter withdraw notice"
                  />
                  <div className="switch-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isWithdrawNoticeActive"
                        checked={settings.isWithdrawNoticeActive}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className="switch-label">Show Notice</span>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Homepage Notice</label>
                  <textarea
                    className="form-textarea"
                    name="HomepageNotice"
                    value={settings.HomepageNotice}
                    onChange={handleChange}
                    placeholder="Enter homepage notice"
                  />
                  <div className="switch-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isHomepageNoticeActive"
                        checked={settings.isHomepageNoticeActive}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className="switch-label">Show Notice</span>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Mainpage Notice</label>
                  <textarea
                    className="form-textarea"
                    name="MainpageNotice"
                    value={settings.MainpageNotice}
                    onChange={handleChange}
                    placeholder="Enter mainpage notice (paste full links starting with https:// — they open for all users)"
                  />
                  <small className="text-muted">
                    Full URLs like https://example.com are shown as clickable links on the main page for everyone (including guests).
                  </small>
                  <div className="switch-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="isMainpageNoticeActive"
                        checked={settings.isMainpageNoticeActive}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className="switch-label">Show Notice</span>
                  </div>
                </div>
              </div>
            </div>
            </TabPanel>

            <TabPanel id="access" activeTab={activeTab}>
            <div className="ss-panel">
              <h2 className="section-title">User Registration</h2>
              <p className="text-muted" style={{ margin: "0 0 14px" }}>
                Also toggled in Quick controls at the top. Save settings after changing.
              </p>
              <QuickToggleCard
                name="newRegistrationEnabled"
                checked={settings.newRegistrationEnabled}
                onChange={handleChange}
                label="Allow new user registration"
              />
              <div className="form-group" style={{ marginTop: 16 }}>
                <label className="form-label">Registration closed message</label>
                <textarea
                  className="form-textarea"
                  name="newRegistrationClosedMessage"
                  value={settings.newRegistrationClosedMessage}
                  onChange={handleChange}
                  disabled={settings.newRegistrationEnabled}
                  placeholder="New user registration is temporarily closed. Existing users can still sign in."
                />
                <small className="text-muted">
                  Shown on the app login page when registration is OFF.
                </small>
              </div>
            </div>

            <div className="ss-panel ss-panel--danger">
              <h2 className="section-title">Maintenance Mode</h2>
              <QuickToggleCard
                name="isMaintenanceMode"
                checked={settings.isMaintenanceMode}
                onChange={handleChange}
                label="Enable maintenance mode"
              />
              <div className="form-group" style={{ marginTop: 16 }}>
                <label className="form-label">Maintenance message</label>
                <textarea
                  className="form-textarea"
                  name="MaintenanceMessage"
                  value={settings.MaintenanceMessage}
                  onChange={handleChange}
                  disabled={!settings.isMaintenanceMode}
                  placeholder="Website is under maintenance. Please try again later."
                />
              </div>
            </div>
            </TabPanel>
          </div>

          <div className="ss-sticky-save">
            <div className="action-buttons">
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <div className="spinner" />
                    Saving...
                  </>
                ) : (
                  "Save all settings"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
      <Gateway />
    </div>
  );
};